document.documentElement.classList.remove('no-js');

const menuToggle = document.querySelector('[data-mobile-toggle]');
const mobileNav = document.querySelector('[data-mobile-nav]');

const closeMenu = () => {
  if (!menuToggle || !mobileNav) return;
  mobileNav.classList.remove('is-open');
  menuToggle.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('menu-open');
};

menuToggle?.addEventListener('click', () => {
  const open = mobileNav?.classList.toggle('is-open');
  menuToggle.setAttribute('aria-expanded', String(Boolean(open)));
  document.body.classList.toggle('menu-open', Boolean(open));
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeMenu();
});

mobileNav?.addEventListener('click', (event) => {
  if (event.target.closest('a')) closeMenu();
});

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const root = select.closest('[data-product-info]');
    const price = root?.querySelector('[data-product-price]');
    const button = root?.querySelector('[data-add-button]');
    const available = option.dataset.available === 'true';

    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      button.disabled = !available;
      button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
    }

    if (option.value && window.history?.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    }
  });
});

document.querySelectorAll('.faq details').forEach((item) => {
  item.addEventListener('toggle', () => {
    if (!item.open) return;
    item.closest('.faq')?.querySelectorAll('details[open]').forEach((other) => {
      if (other !== item) other.removeAttribute('open');
    });
  });
});

document.querySelectorAll('[data-drop-countdown]').forEach((countdown) => {
  const end = new Date(countdown.dataset.dropCountdown).getTime();
  if (!Number.isFinite(end)) {
    countdown.hidden = true;
    return;
  }

  const parts = {
    days: countdown.querySelector('[data-days]'),
    hours: countdown.querySelector('[data-hours]'),
    minutes: countdown.querySelector('[data-minutes]'),
    seconds: countdown.querySelector('[data-seconds]')
  };

  const update = () => {
    const remaining = Math.max(0, end - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60
    };
    Object.entries(values).forEach(([key, value]) => {
      if (parts[key]) parts[key].textContent = String(value).padStart(2, '0');
    });
  };

  update();
  window.setInterval(update, 1000);
});
